import { NavLink, Outlet, useNavigate, Link } from 'react-router-dom'
import clsx from 'clsx'
import { useAuthStore } from '../../context/auth'
import { Logo } from '../../components/brand/Logo'
import { api } from '../../services/api'

const NAV = [
  { to: '/empresa', label: 'Inicio' },
  { to: '/empresa/cotizaciones', label: 'Cotizaciones' },
  { to: '/empresa/trabajadores', label: 'Trabajadores' },
  { to: '/empresa/facturacion', label: 'Facturación' },
]

/** Layout del portal de empresa: header propio + navegación horizontal. */
export function PortalLayout() {
  const { user, refreshToken, logout } = useAuthStore()
  const navigate = useNavigate()

  async function handleLogout() {
    try {
      if (refreshToken) await api.post('/auth/logout', { refreshToken })
    } finally {
      logout()
      navigate('/empresa/login')
    }
  }

  return (
    <div className="flex min-h-screen flex-col bg-surface">
      <header className="bg-brand-900 text-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-3">
          <Link to="/empresa" className="flex items-center gap-2 font-display text-lg">
            <Logo variant="white" className="h-8" />
            <span className="font-normal text-brand-300">· Empresas</span>
          </Link>
          <div className="flex items-center gap-3 text-sm">
            <span className="hidden text-brand-100 sm:inline">
              {user?.firstName} {user?.lastName}
            </span>
            <button onClick={handleLogout} className="rounded bg-brand-700 px-3 py-1.5 text-xs text-brand-100 hover:bg-brand-600">
              Cerrar sesión
            </button>
          </div>
        </div>
        <nav className="mx-auto flex max-w-6xl gap-1 overflow-x-auto px-4 pb-2">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/empresa'}
              className={({ isActive }) =>
                clsx(
                  'whitespace-nowrap rounded-lg px-3 py-1.5 text-sm transition-colors',
                  isActive ? 'bg-brand-600 font-semibold text-white' : 'text-brand-100 hover:bg-brand-700',
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 p-4 md:p-6">
        <Outlet />
      </main>
      <footer className="border-t border-steel-200 bg-white py-4 text-center text-xs text-gray-400">
        Portal de empresas Cima Sport · <Link to="/verificar" className="text-brand-700 hover:underline">Verificar certificados</Link>
      </footer>
    </div>
  )
}
